<style scoped>
#bg-overlay{
  position:absolute;
  width: 100%;
  height:100%;
  top:0;
  left:0;
  background: url('https://images01.nicepage.com/a1389d7bc73adea1e1c1fb7e/ea0fac52522a55e9906dd90c/pexels-photo-1372971-Recovered.jpg');
  background-size: cover;
  background-position: bottom;
}
#loginForm input{
  padding: 0.8rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #dbe0e5;
  border-radius: 8px;
}
#loginForm button{
  padding: 0.8rem 0.75rem;
  font-size: 0.875rem;
  font-weight: 400;
  border: 1px solid #dbe0e5;
  border-radius: 8px;
}
#loginForm input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset !important; 
}
#loginForm input:hover, #loginForm input:active, #loginForm input:focus{
  border-color:rgb(72 123 215);
}
</style>
<script>
import Layout from "../../layouts/auth";


import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
  page: {
    title: "Giriş Yap",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      emailOk: false,
      passwordOk: false,
    };
  },
  validations: {
    email: {
      required,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("authfack", ["loading"]),

    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  mounted(){
      document.getElementById('loginForm').addEventListener('focusin', function() {
        document.getElementById('username').setAttribute('autocomplete', 'new-password');
        document.getElementById('password').setAttribute('autocomplete', 'new-password');
      });
  },

  methods: {

    emailValidity(){
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const r = emailRegex.test(this.email);
      if(r){
        this.emailOk = true
      }else{
         this.emailOk = false
      }
    },

    passwordValidity(){
      if(this.password.length > 3 ){
        this.passwordOk = true
      }else{
         this.passwordOk = false
      }
    },

    tryToLogIn() {
      this.submitted=true;
      this.$store.dispatch("authfack/loadingStatus", true)
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.submitted = false;
        this.$store.dispatch("authfack/loadingStatus", false)
        return;
      } 

      this.$store.dispatch("authfack/login", {
          email: this.email,
          password: this.password,
      });

      this.submitted = false;

    },
  },
  
};
</script>

<template>
  <Layout>
    <div class="row p-5">
      <div id="bg-overlay"></div>
      <div class="mx-auto col-md-8 col-lg-5 col-xl-5">
        <div class="card1">

          <div class="card-body pt-2">
            <h3 class="mt-5 mb-3 text-center">IspCrm Giriş</h3>
            <div style="height: 50px;margin-bottom:10px">
              <b-alert
                v-model="isAuthError"
                variant="danger"
                class="mt-3"
                dismissible
                >{{ authError }}</b-alert
              >
              <div
                v-if="notification.message"
                :class="'alert ' + notification.type"
              >
                {{ notification.message }}
              </div>
            </div>
            <form class="p-2" id="loginForm" @submit.prevent="tryToLogIn" autocomplete="off">
             
                <div class="mb-3">
                    <label class="label text-secondary">Kullanıcı Adı</label>
                    <input  
                      id="username"
                      v-model="email"
                      class="form-control"
                      @input="emailValidity"
                      type="text"
                      placeholder="E-Posta Adresinizi Giriniz"
                      :class="{ 'is-invalid': submitted && $v.email.$error }">
                  <div
                    v-if="submitted && $v.email.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.email.required">E-Posta alanı zorunludur.</span>
                  </div>
              
                </div>
                <div class="mb-4">
                <label class="label text-secondary">Şifre</label>
                <input  
                    id="password"
                    v-model="password"
                    @input="passwordValidity"
                    class="form-control"
                    type="password"
                    placeholder="Şifrenizi Giriniz"
                    :class="{ 'is-invalid': submitted && $v.password.$error }">
                <div
                  v-if="submitted && $v.password.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.password.required">E-Posta alanı zorunludur.</span>
                </div>
              </div>
           
              <div class="d-flex justify-content-end">
                <button 
                    type="submit" 
                    class="btn btn-outline-primary"
                    :disabled="loading">
                    <span v-if="loading"> 
                      <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> Bekleyiniz 
                    </span>
                    <span v-else>
                      <i class="fas fa-sign-in-alt"></i>
                      Giriş Yap
                  </span>
                </button>
              </div>
            </form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
        <div class="mt-5 text-center">
          <p>
            © {{ new Date().getFullYear() }} V.20220628001
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
